import dayjs from 'dayjs';

/**
 * Checks if the provided date is newer than
 * the provided days ago.
 *
 * @param date date to compare against
 * @param days number of days to consider the day is new, from now
 *
 * @example
 * ```ts
 * // checks if blueprints was created more than 7 days ago
 * const isBlueprintNew = isNew(createdAt, 7);
 * ```
 */
export const isNew = (date: Date, days: number) => {
  return dayjs(date).diff(dayjs(), 'day') > -days;
};
